import React, { FC } from 'react';

import { EAssetType } from 'constants/enums';

import Checkbox from 'components/Checkbox/Checkbox';
import { ColorPicker } from 'components/ui/ColorPicker/color-picker';
import UploadImage from 'components/UploadImage/UploadImage';

import {
  FormFieldsBorderRow,
  FormFieldsGradientRow,
  FormFieldsIdentitySection,
  FormFieldsSection,
  FormFieldsUploadSection
} from '../components';

import { useFormFieldsContext } from '../../../context';

import {
  BG_BORDER_ROW_GRADIENT,
  BG_BORDER_ROW_WIDTH,
  BORDER_ROW_GRADIENT,
  BORDER_ROW_WIDTH,
  COLLECT_TEXT_FIELD,
  MAIN_UPLOAD_FIELDS,
  ROLLING_OFFER_DEFAULTS,
  SUB_OFFER_BG_FIELDS
} from './RollingOfferFormFields.consts';

export const RollingOfferFormFields: FC = (): React.ReactElement => {
  const { values, setFieldValue } = useFormFieldsContext();

  return (
    <React.Fragment>
      <FormFieldsSection
        heading="Rolling Offer"
        description="Customize the rolling offer to fit your store theme."
      >
        <FormFieldsIdentitySection
          extraFields={[COLLECT_TEXT_FIELD]}
          spacing="none"
        />
      </FormFieldsSection>

      <FormFieldsSection
        heading="Main Offer Design"
        showSeparator
        headingBottomMargin
      >
        <div className="mb-6">
          <Checkbox
            label="Enable Scroll"
            checked={Boolean(values.enableScroll)}
            onCheckedChange={(checked) => setFieldValue('enableScroll', checked)}
          />
        </div>

        <FormFieldsBorderRow
          gradientConfig={BG_BORDER_ROW_GRADIENT}
          widthConfig={BG_BORDER_ROW_WIDTH}
          spacing="sm"
        />

        <FormFieldsBorderRow
          gradientConfig={BORDER_ROW_GRADIENT}
          widthConfig={BORDER_ROW_WIDTH}
          spacing="sm"
        />

        <div className="flex gap-5 mt-4">
          <div className="flex-1">
            <ColorPicker
              label="Default Arrows Color"
              defaultValue={values.arrowColor || ROLLING_OFFER_DEFAULTS.arrowColor}
              onChange={(color) => setFieldValue('arrowColor', color)}
            />
          </div>
          <div className="flex-1" />
        </div>

        <FormFieldsUploadSection
          fields={MAIN_UPLOAD_FIELDS}
        />
      </FormFieldsSection>

      <FormFieldsSection heading="Sub Offer Design" spacing="xl" headingBottomMargin>
        {/* TODO: Aligned with Jonathan — replace AcGradientInput (MUI) with new component when available */}
        <FormFieldsGradientRow
          fields={SUB_OFFER_BG_FIELDS}
          spacing="sm"
        />

        <div className="mt-5">
          <UploadImage
            title="Offers background image"
            className="w-full !flex flex-row px-5"
            onUpload={(url) => setFieldValue('offersBackgroundImage', url)}
            selectedImageUrl={values.offersBackgroundImage || ''}
            forceType={EAssetType.BG_BUNDLE}
            TooltipContent={() => (
              <span>Upload an image for sub-offer background.</span>
            )}
          />
        </div>
      </FormFieldsSection>
    </React.Fragment>
  );
};
